/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
// import React, { useMemo } from "react";
import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
// import { useSelector } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
// import objectPath from "object-path";
// import { useHtmlClassService } from "../../../_core/MetronicLayout";
// import { toAbsoluteUrl } from "../../../../_helpers";
// import { UserNotificatsionsDropdown } from "../../extras/dropdowns/UserNotificationsDropdown";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { makeStyles, Popover, Typography ,Button  } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

export function UserProfileDropdown() {

  // popover ---------------------------------------------------------------------
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
 // popover ---------------------------------------------------------------------

  // const { user } = useSelector((state) => state.auth);
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  // const uiService = useHtmlClassService();
  // const layoutProps = useMemo(() => {
  //   return {
  //     light:
  //       objectPath.get(uiService.config, "extras.user.dropdown.style") ===
  //       "light",
  //     viewNotificationsDisplay: objectPath.get(
  //       uiService.config,
  //       "extras.notifications.display"
  //     ),
  //   };
  // }, [uiService]);

  // return (
  //   <Dropdown drop="down" alignRight>
  //     <Dropdown.Toggle
  //       as={DropdownTopbarItemToggler}
  //       id="dropdown-toggle-user-profile"
  //     >
  //       <div
  //         className={
  //           "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
  //         }
  //       >
  //         <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
  //           Hello,
  //         </span>{" "}
  //         <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
  //           {user.firstname} {user.lastname}
  //         </span>
  //         <span className="symbol symbol-35 symbol-light-success">
  //         <div className="navi-footer  px-8 py-5">
  //         <Link
  //           to="/logout"
  //           className="btn btn-light-primary font-weight-bold"
  //         >
  //           Sign Out
  //         </Link>
  //         <a href="#" className="btn btn-clean font-weight-bold">
  //           Upgrade Plan
  //         </a>
  //       </div>
  //         </span>
  //       </div>
  //     </Dropdown.Toggle>
  //     <Dropdown.Menu className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
  //       <>
  //         {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
  //         {layoutProps.light && (
  //           <>
  //             <div className="d-flex align-items-center p-8 rounded-top">
  //               <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
  //                 <img src={toAbsoluteUrl("/media/users/300_21.jpg")} alt="" />
  //               </div>
  //               <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">
  //                 {user.firstname} {user.lastname}
  //               </div>
  //               <span className="label label-light-success label-lg font-weight-bold label-inline">
  //                 3 messages
  //               </span>
  //             </div>
  //             <div className="separator separator-solid"></div>
  //           </>
  //         )}

  //         {!layoutProps.light && (
  //           <div
  //             className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
  //             style={{
  //               backgroundImage: `url(${toAbsoluteUrl(
  //                 "/media/misc/bg-1.jpg"
  //               )})`,
  //             }}
  //           >
  //             <div className="symbol bg-white-o-15 mr-3">
  //               <span className="symbol-label text-success font-weight-bold font-size-h4">
  //                 {user.firstname[0]}
  //               </span>
  //               {/*<img alt="Pic" className="hidden" src={user.pic} />*/}
  //             </div>
  //             <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
  //               {user.firstname} {user.lastname}
  //             </div>
  //             <span className="label label-success label-lg font-weight-bold label-inline">
  //               3 messages
  //             </span>
  //           </div>
  //         )}
  //       </>

  //       <div className="navi navi-spacer-x-0 pt-5">
  //         <Link to="/user-profile" className="navi-item px-8 cursor-pointer">
  //           <div className="navi-link">
  //             <div className="navi-icon mr-2">
  //               <i className="flaticon2-calendar-3 text-success" />
  //             </div>
  //             <div className="navi-text">
  //               <div className="font-weight-bold cursor-pointer">
  //                 My Profile
  //               </div>
  //               <div className="text-muted">
  //                 Account settings and more
  //                 <span className="label label-light-danger label-inline font-weight-bold">
  //                   update
  //                 </span>
  //               </div>
  //             </div>
  //           </div>
  //         </Link>

  //         <a className="navi-item px-8">
  //           <div className="navi-link">
  //             <div className="navi-icon mr-2">
  //               <i className="flaticon2-mail text-warning"></i>
  //             </div>
  //             <div className="navi-text">
  //               <div className="font-weight-bold">My Messages</div>
  //               <div className="text-muted">Inbox and tasks</div>
  //             </div>
  //           </div>
  //         </a>

  //         <a className="navi-item px-8">
  //           <div className="navi-link">
  //             <div className="navi-icon mr-2">
  //               <i className="flaticon2-rocket-1 text-danger"></i>
  //             </div>
  //             <div className="navi-text">
  //               <div className="font-weight-bold">My Activities</div>
  //               <div className="text-muted">Logs and notifications</div>
  //             </div>
  //           </div>
  //         </a>

  //         <a className="navi-item px-8">
  //           <div className="navi-link">
  //             <div className="navi-icon mr-2">
  //               <i className="flaticon2-hourglass text-primary"></i>
  //             </div>
  //             <div className="navi-text">
  //               <div className="font-weight-bold">My Tasks</div>
  //               <div className="text-muted">latest tasks and projects</div>
  //             </div>
  //           </div>
  //         </a>
  //         <div className="navi-separator mt-3"></div>

  //         <div className="navi-footer  px-8 py-5">
  //           <Link
  //             to="/logout"
  //             className="btn btn-light-primary font-weight-bold"
  //           >
  //             Sign Out
  //           </Link>
  //           <a href="#" className="btn btn-clean font-weight-bold">
  //             Upgrade Plan
  //           </a>
  //         </div>
  //       </div>
  //     </Dropdown.Menu>
  //   </Dropdown>
  // );
  return (
    <Dropdown drop="down" alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id="dropdown-toggle-user-profile"
      >
          <Button onClick={handleClick} className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {user.name}
          </Button>
          <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography className={classes.typography}>
          <Link to="/Registration">修改密碼</Link>
        </Typography>
      </Popover>
          <span className="symbol symbol-35 symbol-light-success">
            <div className="navi-footer  px-8 py-5">
              <Link
                to="/logout"
                className="btn btn-light-primary font-weight-bold"
              >
                登出
              </Link>
            </div>
          </span>
        
      </Dropdown.Toggle>
    </Dropdown>
  );
}
